import React, { useEffect, useState } from 'react';
export const VisionSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const element = document.getElementById('vision');
      if (element) {
        const position = element.getBoundingClientRect();
        if (position.top < window.innerHeight * 0.75) {
          setIsVisible(true);
        }
      }
    };
    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Check on initial load
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <section id="vision" className="py-24 bg-gradient-to-r from-navy-800 via-navy-900 to-navy-800 relative overflow-hidden" data-id="element-11464">
      <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1514320291840-2e0a9bf2a9ae?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80')] bg-cover bg-center opacity-5" data-id="element-11465"></div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-11466">
        <div className={`transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-11467">
          <div className="text-center mb-8" data-id="element-11468">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-6" data-id="element-11469">
              Our Vision for the Future of Music Education
            </h2>
          </div>
          <div className="max-w-4xl mx-auto" data-id="element-11470">
            <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl p-8 md:p-10 shadow-lg" data-id="element-11471">
              <div className="absolute -inset-1 bg-gradient-to-r from-lavender/5 via-deep-pink/5 to-golden/5 opacity-30 blur-xl rounded-2xl" data-id="element-11472"></div>
              <p className="text-lg md:text-xl text-gray-200 mb-6 leading-relaxed" data-id="element-11473">
                We believe the future of music education should be{' '}
                <strong data-id="element-11474">
                  teacher-driven, transparent, and built on real musical
                  experience
                </strong>{' '}
                — not generic platforms or one-size-fits-all systems.
              </p>
              <p className="text-lg md:text-xl text-gray-200 mb-6 leading-relaxed" data-id="element-11475">
                MaestroConnect is designed to grow into a trusted ecosystem
                where independent music teachers can build sustainable studios,
                share knowledge, and support students in meaningful ways. Our
                focus is on supporting high-quality teaching through better
                tools, clearer communication, and a more modern learning
                experience.
              </p>
              <p className="text-lg md:text-xl text-gray-200 leading-relaxed" data-id="element-11476">
                As the platform evolves, our vision is to expand opportunities
                for both teachers and students through curated content, advanced
                learning tools, and new ways to engage with music education —
                always guided by the needs of educators and the realities of
                teaching music today.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
};